import { ToggleButton, toggleButtonClasses } from '@mui/material';
import { createPlanPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { VyIcon } from '@vy/ui-design-system';
import React from 'react';
import type { useDialog } from '../../../../hooks/use-dialog';

type ModifyButtonProps = Partial<ReturnType<typeof useDialog>>;

export const ModifyButton: React.FC<ModifyButtonProps> = ({ isDialogOpen, handleOpen }) => {
  return (
    <ToggleButton
      {...getSelectorAttribute(createPlanPageSelectors.drawer.modifyButton)}
      className="min-w-fit"
      value="modify"
      sx={{
        fontWeight: '400',
        fontSize: '14px',
        boxShadow: 'none',
        columnGap: '10px',
        borderRadius: '6px',
        padding: '6px 12px',
        border: 'none',
        textTransform: 'none',
        color: '#0D1B27DE',
        backgroundColor: '#ECEDEE',
        [`&.${toggleButtonClasses.selected}`]: {
          backgroundColor: '#DADBDD',
          '&:hover': {
            backgroundColor: '#DADBDD',
          },
        },
      }}
      onClick={handleOpen}
      selected={isDialogOpen}
    >
      <VyIcon color="#576063" icon="Edit2" />
      <span>Modify</span>
    </ToggleButton>
  );
};
